var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowNavLink = function SvgArrowNavLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.263 12.444a.706.706 0 0 1 0 .998L12.5 17.206a.706.706 0 0 1-.998 0l-3.765-3.764a.706.706 0 0 1 .998-.998l2.56 2.559V7.296a.706.706 0 1 1 1.412 0v7.707l2.56-2.559a.706.706 0 0 1 .997 0Z",
    fill: "currentColor"
  })));
};
export default SvgArrowNavLink;